export const ORG_HIERARCHY_FIELDS = [
  "region",
  "office",
  "division",
  "section",
  "unit",
  "cluster",
];

const ORG_FIELD_TO_COLLECTION = {
  region: "Region",
  office: "offices",
  division: "Division",
  section: "Sections",
  unit: "Units",
  cluster: "Clusters",
};

export function hasOrganizationFields(fields = []) {
  return fields.some((field) => ORG_HIERARCHY_FIELDS.includes(field));
}

export async function loadOrganizationNameMaps(findObjectUseCase) {
  const query = { keys: ["name"], where: { status: "active" } };
  const results = await Promise.all(
    ORG_HIERARCHY_FIELDS.map((field) =>
      findObjectUseCase.execute(ORG_FIELD_TO_COLLECTION[field], query),
    ),
  );

  const toMap = (list) =>
    new Map((list || []).map((item) => [item.id, item.name || ""]));

  return Object.fromEntries(
    ORG_HIERARCHY_FIELDS.map((field, index) => [field, toMap(results[index])]),
  );
}

export function resolveOrganizationFields(objects, maps) {
  objects.forEach((object) => {
    ORG_HIERARCHY_FIELDS.forEach((field) => {
      const value = object[field];
      if (value != null && value !== "") {
        object[field] = maps[field]?.get(value) || "";
      }
    });
  });
  return objects;
}
